<template>
    <!-- START: form -->
    <div class="form">

        <div aria-live="polite" class="sr-only">
            <span v-if="loading">Formular wird gesendet.</span>
        </div>

        <div class="loader" v-if="loading">
            <medium-loader />
        </div>

        <!-- START: formular -->
        <form class="needs-validation" novalidate v-else>

          <div class="alert alert-danger" v-if="errorMessage" role="alert" aria-atomic="true"><p>{{ errorMessage }}</p></div>

            <div class="summary-heading d-flex align-items-center">
                <h2 class="p-0 mb-1">Ihre Lieferadresse</h2>
                <button @click.prevent="$emit('changeTab', 0, '#lieferadresse')" type="button" class="edit-details" data-trigger="hover" data-container="body" v-popover data-placement="top" data-content="Angaben ändern" data-original-title="" title="">Angaben ändern</button>
            </div>

            <table class="table-customerdata">
                <colgroup>
                    <col width="50%">
                    <col width="50%">
                </colgroup>
                <tbody>
                <tr>
                    <th scope="row">Kundentyp</th>
                    <td v-if="formData.lieferadresse_anrede == 'Firma'">Geschäftskunde</td>
                    <td v-else>Privatkunde</td>
                </tr>
                <tr v-if="formData.lieferadresse_anrede == 'Firma'">
                    <th scope="row">Firmenname</th>
                    <td>{{ formData.lieferadresse_firma }}</td>
                </tr>
                <tr>
                    <th scope="row">Anrede</th>
                    <td>{{ formData.lieferadresse_anrede }} {{ formData.lieferadresse_titel }}</td>
                </tr>
                <tr>
                    <th scope="row">Name</th>
                    <td>{{ formData.lieferadresse_vorname }} {{ formData.lieferadresse_nachname }}</td>
                </tr>
                <tr v-if="formData.lieferadresse_vorname2 || formData.lieferadresse_nachname2">
                    <th scope="row">Name zweite Person</th>
                    <td>{{ formData.lieferadresse_vorname2 }} {{ formData.lieferadresse_nachname2 }}</td>
                </tr>
                <tr>
                    <th scope="row">Geburtsdatum</th>
                    <td>{{ formData.lieferadresse_geburtsdatum }}</td>
                </tr>
                <tr>
                    <th scope="row">Straße</th>
                    <td>{{ formData.lieferadresse_strasse }} {{ formData.lieferadresse_hausnummer }}{{ formData.lieferadresse_hausnummer_zusatz }}</td>
                </tr>
                <tr>
                    <th scope="row">Postleitzahl, Ort</th>
                    <td>{{ formData.lieferadresse_plz }}, {{ formData.lieferadresse_ort }}</td>
                </tr>
                </tbody>
            </table>

            <div class="custom-control custom-checkbox" style="margin-bottom:0.5rem;">
                <input class="custom-control-input" type="checkbox" :checked="formData.rechnungsadresse_abweichend" disabled>
                <label class="custom-control-label">Rechnungs- und Lieferanschrift weichen voneinander ab</label>
            </div>

            <template v-if="formData.rechnungsadresse_abweichend">
                <div class="summary-heading">
                    <h2>Ihre Rechnungsadresse</h2>
                    <button @click.prevent="$emit('changeTab', 0, '#abweichAdr')" type="button" class="edit-details" data-trigger="hover" data-container="body" v-popover data-placement="top" data-content="Angaben ändern" data-original-title="" title="">Angaben ändern</button>
                </div>

                <table class="table-customerdata">
                    <colgroup>
                        <col width="50%">
                        <col width="50%">
                    </colgroup>
                    <tbody>
                    <tr>
                        <th scope="row">Straße</th>
                        <td>{{ formData.rechnungsadresse_strasse }} {{ formData.rechnungsadresse_hausnummer }}{{ formData.rechnungsadresse_hausnummer_zusatz }}</td>
                    </tr>
                    <tr>
                        <th scope="row">Postleitzahl, Ort</th>
                        <td>{{ formData.rechnungsadresse_plz }}, {{ formData.rechnungsadresse_ort }}</td>
                    </tr>
                    </tbody>
                </table>
            </template>

            <div class="summary-heading d-flex align-items-center">
                <h2 class="p-0 mb-1">Ihre Kontaktdaten</h2>
                <button @click.prevent="$emit('changeTab', 0, '#contact')" type="button" class="edit-details" data-trigger="hover" data-container="body" v-popover data-placement="top" data-content="Angaben ändern" data-original-title="" title="">Angaben ändern</button>
            </div>

            <table class="table-customerdata">
                <colgroup>
                    <col width="50%">
                    <col width="50%">
                </colgroup>
                <tbody>
                <tr>
                    <th scope="row">Telefonnummer</th>
                    <td>{{ formData.telefon }}</td>
                </tr>
                <tr>
                    <th scope="row">E-Mail-Adresse</th>
                    <td>{{ formData.email}}</td>
                </tr>
                </tbody>
            </table>

            <div class="summary-heading d-flex align-items-center">
                <h2 class="p-0 mb-1">Ihre Anschlussdaten</h2>
                <button @click.prevent="$emit('changeTab', 1, '#anschluss')" type="button" class="edit-details" data-trigger="hover" data-container="body" v-popover data-placement="top" data-content="Angaben ändern" data-original-title="" title="">Angaben ändern</button>
            </div>

            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="z_kunde" checked disabled>
                <label class="custom-control-label" for="z_kunde" v-if="formData.kunde_bestandskunde && formData.kunde_meldetyp === 'einzug'">Ich bin bereits Kunde der Stadtwerke Bochum und möchte meinen Einzug melden</label>
                <label class="custom-control-label" for="z_kunde" v-else-if="formData.kunde_bestandskunde && formData.kunde_meldetyp === 'wechsel'">Ich bin bereits Kunde der Stadtwerke Bochum und möchte meinen Tarif wechseln</label>
                <label class="custom-control-label" for="z_kunde" v-else-if="!formData.kunde_bestandskunde && formData.kunde_meldetyp === 'einzug'">Ich möchte Kunde der Stadtwerke Bochum werden und meinen Einzug melden</label>
                <label class="custom-control-label" for="z_kunde" v-else-if="!formData.kunde_bestandskunde && formData.kunde_meldetyp === 'wechsel'">Ich möchte Kunde der Stadtwerke Bochum werden und meinen Lieferanten wechseln</label>
            </div>

            <table class="table-customerdata">
                <colgroup>
                    <col width="50%">
                    <col width="50%">
                </colgroup>
                <tbody>
                <tr v-if="formData.kunde_bestandskunde">
                    <th scope="row">Kundennummer</th>
                    <td>{{ formData.kunde_kundennummer }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'einzug'">
                    <th scope="row">Einzugsdatum</th>
                    <td>{{ formData.kunde_einzugsdatum }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'wechsel'">
                    <th scope="row">Ihr Wunschtermin</th>
                    <td>{{ formData.kunde_wunschtermin }}</td>
                </tr>
                <tr>
                    <th scope="row">Zählernummer</th>
                    <td>{{ formData.kunde_zaehlernummer }}</td>
                </tr>
                <tr v-if="formData.kunde_marktlokations_id">
                    <th scope="row">Marktlokations-ID</th>
                    <td>{{ formData.kunde_marktlokations_id }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'einzug'">
                    <th scope="row">Zählerstand</th>
                    <td>{{ formData.kunde_zaehlerstand }} kWh</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'einzug'">
                    <th scope="row">Tag der Ablesung</th>
                    <td>{{ formData.kunde_zaehlerablesung }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                    <th scope="row">Vorlieferant</th>
                    <td>{{ formData.kunde_vorversorger }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                    <th scope="row">Kundennummer Vorlieferant</th>
                    <td>{{ formData.kunde_vorversorger_kundennummer }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                    <th scope="row">Vertragsende</th>
                    <td>{{ formData.kunde_vorversorger_vertragsende }}</td>
                </tr>
                <tr v-if="formData.kunde_meldetyp === 'einzug'">
                    <th scope="row">Datum der Schlüsselübergabe</th>
                    <td>{{ formData.kunde_schluesseldatum }}</td>
                </tr>
                </tbody>
            </table>

            <div class="custom-control custom-checkbox" v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                <input class="custom-control-input" type="checkbox" id="z_vl_gekuendigt" :checked="formData.kunde_vorversorger_gekuendigt" disabled>
                <label class="custom-control-label" for="z_vl_gekuendigt">Ich habe bereits gekündigt</label>
            </div>

            <br>

            <div class="summary-heading d-flex align-items-center">
                <h2 class="p-0 mb-1">Ihre Zahlungsdaten</h2>
                <button @click.prevent="$emit('changeTab', 1, '#bankdaten')" type="button" class="edit-details" v-popover data-trigger="hover" data-container="body" data-placement="top" data-content="Angaben ändern" data-original-title="" title="">Angaben ändern</button>
            </div>

            <table class="table-customerdata">
                <colgroup>
                    <col width="50%">
                    <col width="50%">
                </colgroup>
                <tbody>
                <tr>
                    <th scope="row">Zahlungsmethode</th>
                    <td>{{ formData.rechnung_typ === 'SEPA' ? 'SEPA-Lastschrift' : 'Überweisung' }}</td>
                </tr>
                <template v-if="formData.rechnung_typ === 'SEPA'">
                    <tr>
                        <th scope="row">IBAN</th>
                        <td>{{ formData.sepa_iban }}</td>
                    </tr>
                    <tr>
                        <th scope="row">Kontoinhaber</th>
                        <td>{{ formData.sepa_kontoinhaber }}</td>
                    </tr>
                    <tr>
                        <th scope="row">SEPA-Mandat erteilt</th>
                        <td>{{ formData.rechnung_typ === 'SEPA' && settings.willenserklaerungen.zahlung_sepa.length ? 'Ja' : 'Nein' }}</td>
                    </tr>
                </template>
                <tr>
                    <th scope="row">Rabatt für Jahresvorauszahlung</th>
                    <td>{{ formData.jvl }} %</td>
                </tr>

                <tr v-if="formData.gutschein">
                    <th scope="row">Gutscheincode</th>
                    <td>{{ formData.gutschein }}</td>
                </tr>

                </tbody>
            </table>

            <template v-if="formData.rechnung_typ === 'SEPA' && settings.willenserklaerungen.zahlung_sepa.length">
                <checkbox-input v-for="w in settings.willenserklaerungen.zahlung_sepa" :name="'willenserklaerung_' + w.uid" :label="w.erklaerung" :key="w.uid" disabled />
            </template>

            <template v-if="formData.rechnung_typ === 'Überweisung' && settings.willenserklaerungen.zahlung_ueberweisung.length">
                <checkbox-input v-for="w in settings.willenserklaerungen.zahlung_ueberweisung" :name="'willenserklaerung_' + w.uid" :label="w.erklaerung" :key="w.uid" disabled />
            </template>

            <br>
            <h2>Online-Kundencenter inkl. Online-Rechnung</h2>
            <p>
                Sie werden automatisch für das Online-Kundencenter registriert und erhalten zukünftig Ihre Rechnung online. Weitere Dokumente und Briefe senden wir Ihnen ebenfalls digital in Ihr Online-Postfach. Bequem, papierlos und damit umweltfreundlich!
            </p>

            <template v-if="settings.tarif.postrechnung">
                <checkbox-input name="rechnung_post" :label="settings.tarif.postrechnung_erklaerung" disabled/>
            </template>

            <br>

            <div class="summary-heading d-flex align-items-center">
                <h2 class="p-0 mb-1">Ihre Willenserklärung</h2>
                <button @click.prevent="$emit('changeTab', 1, '#willenserklaerungen')" type="button" class="edit-details" data-trigger="hover" data-container="body" v-popover data-placement="top" data-content="Angaben ändern" data-original-title="" title="">Angaben ändern</button>
            </div>

            <div style="display: flex; flex-flow: column; gap: 1em;">
                <checkbox-input v-for="w in settings.willenserklaerungen.checkout" :name="'willenserklaerung_' + w.uid" :label="w.erklaerung" :key="w.uid" disabled />
            </div>

            <br>

            <template v-if="settings.willenserklaerungen.newsletter.length">
                <h2>Newsletter "Meine Stadtwerke"</h2>

                <checkbox-input v-for="w in settings.willenserklaerungen.newsletter" :name="'willenserklaerung_' + w.uid" :label="w.erklaerung" :key="w.uid" disabled />

                <br>
            </template>

            <p><small>Mit * markierte Felder sind Pflichtfelder.</small></p>

            <!-- <br>

            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="pdf" >
                <label class="custom-control-label" for="pdf">Bestellzusammenfassung als PDF speichern</label>
            </div> -->

            <br>

            <div class="form-buttons">
                <button class="btn btn-secondary btn-back" type="button" @click.prevent="$emit('prev')">Zurück</button>
                <button class="btn btn-secondary btn-next" type="button" @click.prevent="$emit('next')">Zahlungspflichtig bestellen</button>
            </div>
        </form>
        <!-- END: formular -->
    </div>
    <!-- END: form -->
</template>
<script>
import CheckboxInput from "@/components/Form/CheckboxInput";
import MediumLoader from "@/components/Loader/MediumLoader";

export default {
    name: 'BestellstreckeFormZusammenfassung',
    inject: ['settings'],
    props: ['formData', 'errorMessage', 'loading'],
    components: {CheckboxInput, MediumLoader},
    mounted() {
        if (typeof window.tab3mounted === 'function') {
            window.tab3mounted();
        }
    },
}
</script>
